/* ======================================================================== */
/* 66. SliderBackgrounds */
/* ======================================================================== */
var SliderBackgrounds = function ($backgrounds) {

	var
		$sliders = $('.section-headings-slider'),
		$ajaxLinks = $('.slider [data-slide-id]');

	$ajaxLinks
		.on('mouseenter touchstart', function () {
			var
				postId = $(this).data('slide-id'),
				$targetBackground = $backgrounds.filter('[data-background-for="' + postId + '"]');

			if (!$targetBackground.length) {
				return;
			}

			$targetBackground.addClass('active');

			// don't do anything on dark pages
			if ($('.page-wrapper').attr('data-barba-namespace') == 'dark') {
				return;
			}

			window.$header.removeClass('header_black').addClass('header_white');
			$sliders.addClass('color-white');

		})
		.on('mouseleave touchend', function () {

			$backgrounds.filter('.active').removeClass('active');

			// don't do anything on dark pages
			if ($('.page-wrapper').attr('data-barba-namespace') == 'dark') {
				return;
			}

			window.$header.removeClass('header_white').addClass('header_black');
			$sliders.removeClass('color-white');

		})
		.on('click', function () {

			var
				postId = $(this).data('slide-id'),
				$targetBackground = $backgrounds.filter('[data-background-for="' + postId + '"]'),
				$targetBackgroundGlobal = window.$backgrounds.filter('[data-background-for="' + postId + '"]');

			if (!$targetBackground.length || typeof elementor != 'undefined') {
				return;
			}

			$backgrounds.filter('active').removeClass('active');
			$targetBackgroundGlobal.addClass('selected');
			$targetBackground.addClass('selected');

		});

}
